import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthShell } from "@/pages/Login";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setBusy(true);
    try {
      await register(name, email, password);
      toast.success("Account created");
      nav("/create");
    } catch (err) {
      toast.error(apiErr(err));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell>
      <h1 className="font-display text-3xl font-semibold tracking-tight text-foreground">Create your account</h1>
      <p className="mt-2 text-muted-foreground">Start telling stories through time.</p>
      <form onSubmit={submit} className="mt-8 space-y-4" data-testid="register-form">
        <div>
          <Label htmlFor="name">Name</Label>
          <Input id="name" required value={name} onChange={(e) => setName(e.target.value)} className="mt-1.5 h-11" data-testid="register-name" placeholder="Sarv" />
        </div>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11" data-testid="register-email" placeholder="you@example.com" />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11" data-testid="register-password" placeholder="At least 6 characters" />
        </div>
        <Button type="submit" disabled={busy} className="w-full h-11 rounded-full" data-testid="register-submit">{busy ? "Creating…" : "Create account"}</Button>
      </form>
      <p className="mt-6 text-sm text-muted-foreground">Already have an account? <Link to="/login" className="text-primary font-medium hover:underline" data-testid="to-login">Log in</Link></p>
    </AuthShell>
  );
}
